import React, { ReactElement } from "react";
import { Instance } from "mobx-state-tree";
import { RegularSingleSelectQuestionModelV1 } from "../models/RegularSingleSelectQuestionModelV1";
import {
  CornerRadius,
  FoundationColorTokens,
  Shadow,
  Spacing,
  Typography,
} from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";
import { BorderStyle } from "@pulse/shared-components";
import { SurveyQuestionViewStoreNames } from "../stores/SurveyViewDetailsStore";
import { QuestionView } from "./QuestionView";
import { QuestionTypeGraphs } from "./ChartSelection";
import { observer } from "mobx-react";
import { getButtonProps, UpdateQuestionViewParams } from "./QuestionViews";
import { SignInStore } from "../../auth/store/SignInStore";

interface RegularSingleSelectQuestionViewProps {
  surveyQuestionView: Instance<typeof RegularSingleSelectQuestionModelV1>;
  typography: Typography;
  t: TFunction;
  tokens: FoundationColorTokens<string>;
  spacing: Spacing;
  border: BorderStyle;
  cornerRadius: CornerRadius;
  boxShadow: Shadow;
  updateQuestionViewParams?: UpdateQuestionViewParams;
  isSurveyViewOptionDisplayTextSelected: boolean;
  allowSPoCToSelectGraphType: boolean;
  signInStore: Instance<typeof SignInStore>;
}

export const RegularSingleSelectQuestionView = observer(
  ({
    surveyQuestionView,
    spacing,
    t,
    tokens,
    typography,
    border,
    cornerRadius,
    boxShadow,
    updateQuestionViewParams,
    isSurveyViewOptionDisplayTextSelected,
    allowSPoCToSelectGraphType,
    signInStore,
  }: RegularSingleSelectQuestionViewProps): ReactElement => {
    return (
      <QuestionView
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
        cornerRadius={cornerRadius}
        border={border}
        questionText={surveyQuestionView.question}
        sampleBreakdown={surveyQuestionView.sampleBreakdown}
        total={surveyQuestionView.sampleBreakdown.total}
        selectedGraph={
          QuestionTypeGraphs[surveyQuestionView.updatedSingleSelectGraphType]
        }
        surveyQuestionViewType={
          SurveyQuestionViewStoreNames.REGULAR_SINGLE_SELECT_QUESTION_MODEL
        }
        updateSelectedGraphType={surveyQuestionView.updateSelectedGraphType}
        data={surveyQuestionView.singleSelectResults.map(
          (singleSelectResult) => {
            return {
              option: isSurveyViewOptionDisplayTextSelected
                ? singleSelectResult.answer.answer
                : singleSelectResult.answer.code,
              count: singleSelectResult.count,
              percentage: singleSelectResult.percentage,
              id: singleSelectResult.answer.code,
              isSurveyViewOptionDisplayTextSelected,
            };
          },
        )}
        buttonProps={getButtonProps(
          updateQuestionViewParams,
          surveyQuestionView.surveyQuestionViewId,
          surveyQuestionView.questionViewGraphType,
          surveyQuestionView.isGraphSelectionUpdated,
          surveyQuestionView.updateSelectedGraphTypeWithUpdatedGraph,
        )}
        boxShadow={boxShadow}
        isChildQuestion={updateQuestionViewParams === undefined}
        isSurveyViewOptionDisplayTextSelected={
          isSurveyViewOptionDisplayTextSelected
        }
        allowSPoCToSelectGraphType={allowSPoCToSelectGraphType}
        signInStore={signInStore}
      />
    );
  },
);
